import { PERMISSION } from "../components/investigation/share/user_roles";

// Sentinel uuid: stored in localStorage and passed to selectInvestigation() to
// trigger the grouped ("All my investigations") view. It is NOT a real investigation
// uuid and is never used as `currentInvestigation` — the groupedMode flag drives the
// aggregated view while currentInvestigation always stays a real investigation.
export const GROUPED_INVESTIGATION_UUID = "__ALL__";

// True if the researcher holds CROSS_INVESTIGATION_VIEW in at least one investigation.
// /investigation/all returns each investigation's `permissions` array at login, so this
// can be evaluated before any investigation is selected.
export function canUseGroupedView(realInvestigations: any[]): boolean {
    return (realInvestigations || []).some(
        inv => (inv.permissions || []).includes(PERMISSION.CROSS_INVESTIGATION_VIEW)
    );
}

// The investigations the grouped view aggregates: those where the researcher holds
// CROSS_INVESTIGATION_VIEW.
export function groupedInvestigations(realInvestigations: any[]): any[] {
    return (realInvestigations || []).filter(
        inv => (inv.permissions || []).includes(PERMISSION.CROSS_INVESTIGATION_VIEW)
    );
}
